import React from "react";
import TimeLineAccordion from "../TimeLineAccordion";
import {
  VerticalLineDesktop,
  VerticalLineDesktopRel
} from "../../Epics/Grants/Pages/HowItWorks/styles";
import TimeLineStatus from "../TimeLineAccordion/TimeLineStatus";

export default ({ desktopRefs = [], howItWorksDetails, handleScrollToTOp }) => {
  return (
    <div className="howItWorksDesktop"  data-test="GrantStep">
      <TimeLineAccordion
        stepCount={1}
        howItWorksDetails={howItWorksDetails}
        myCustomRef={desktopRefs[0]}
        handleScrollToTOp={handleScrollToTOp}
      />
      <VerticalLineDesktop />
      <TimeLineAccordion
        stepCount={2}
        howItWorksDetails={howItWorksDetails}
        myCustomRef={desktopRefs[1]}
        handleScrollToTOp={handleScrollToTOp}
      />

      <VerticalLineDesktopRel />

      <TimeLineStatus
        statusTitle={howItWorksDetails.field_step_2_status_title}
        statusOne={howItWorksDetails.field_step_2_status_1}
        statusOneTooltip={howItWorksDetails.field_step_2_status_1_tooltip}
        statusTwo={howItWorksDetails.field_step_2_status_2}
        statusTwoTooltip={howItWorksDetails.field_step_2_status_2_tooltip}
        isMobile={false}
        type={2}
      />
      <VerticalLineDesktop />

      <TimeLineAccordion
        stepCount={3}
        howItWorksDetails={howItWorksDetails}
        myCustomRef={desktopRefs[2]}
        handleScrollToTOp={handleScrollToTOp}
      />

      <VerticalLineDesktopRel />

      <TimeLineStatus
        statusTitle={howItWorksDetails.field_step_3_status_title}
        statusOne={howItWorksDetails.field_step_3_status_1}
        statusOneTooltip={howItWorksDetails.field_step_3_status_1_tooltip}
        statusTwo={howItWorksDetails.field_step_3_status_2}
        statusTwoTooltip={howItWorksDetails.field_step_3_status_2_tooltip}
        isMobile={false}
        type={3}
      />

      <VerticalLineDesktop />

      <TimeLineAccordion
        stepCount={4}
        howItWorksDetails={howItWorksDetails}
        myCustomRef={desktopRefs[3]}
        handleScrollToTOp={handleScrollToTOp}
      />

      <VerticalLineDesktopRel />

      <TimeLineStatus
        statusTitle={howItWorksDetails.field_step_4_status_title}
        statusOne={howItWorksDetails.field_step_4_status_1}
        statusOneTooltip={howItWorksDetails.field_step_4_status_1_tooltip}
        statusTwo={howItWorksDetails.field_step_4_status_2}
        statusTwoTooltip={howItWorksDetails.field_step_4_status_2_tooltip}
        isMobile={false}
        type={4}
      />
    </div>
  );
};
